import React from "react";

interface AssessmentCardProps {
  title: string;
  score: number | string;
  maxScore?: number;
  description: string;
  color?: string;
  // [2026-10-08] ADDED — INC-1785: the score could not be measured, so no "/10" is shown.
  notAvailable?: boolean;
}

const AssessmentCard: React.FC<AssessmentCardProps> = ({
  title,
  score,
  maxScore,
  description,
  color = "blue",
  notAvailable = false,
}) => {
  const getBackgroundColor = () => {
    switch (color) {
      case "green":
        return "bg-green-50 border-green-200";
      case "red":
        return "bg-red-50 border-red-200";
      default:
        return "bg-blue-50 border-blue-200";
    }
  };

  const getTextColor = () => {
    switch (color) {
      case "green":
        return "text-green-600";
      case "red":
        return "text-red-600";
      default:
        return "text-blue-600";
    }
  };

  return (
    <div className={`p-2 md:p-3 rounded-lg border ${getBackgroundColor()}`}>
      <div className="text-center">
        <div className={`text-2xl md:text-3xl font-bold ${getTextColor()} mb-2`}>
          {score}
          {/* [2026-10-08] CHANGED — INC-1785: "/10" is left off a score that is not available. Old line: */}
          {/* {<span className="text-sm md:text-lg text-gray-500">/10</span>} */}
          {!notAvailable && <span className="text-sm md:text-lg text-gray-500">/10</span>}
        </div>
        <h3 className="text-sm md:text-md font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-xs md:text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default AssessmentCard;
